import React from "react";

const Footer = () => {
    return (
        <div>
            <p className="text-center mt-5">
                Developed & Maintain by{" "}
                <span className="title-color">Saurav Ghosh</span>
            </p>
        </div>
    );
};

export default Footer;
